import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Java">
                <h1>
                  Java Development Company For Exquisite Android App Solutions
                </h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol is a Java development company providing native
                  Android app solutions for startups, mid-market, and
                  enterprise-level organizations. Our Android app solutions
                  enable unprecedented business growth.
                </p>
                <ul>
                  <li>Customized Android Apps</li>
                  <li>Unprecedented Business Growth</li>
                  <li>Native App Development</li>
                  <li>Enterprise-level Solutions</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
